module.exports = __webpack_public_path__ + "static/media/survey_icon.9d2b14b2.svg";